import { MotionConfig } from 'framer-motion';
import AppRouter from './router';
import { motionTokens } from '@/tokens/motion';

function App() {
  return (
    <MotionConfig 
      reducedMotion="user"
      transition={{ 
        duration: motionTokens.duration.normal,
        ease: motionTokens.ease.default,
      }}
    >
      <div className="App bg-background text-textPrimary min-h-screen">
        <AppRouter />
      </div>
    </MotionConfig>
  );
}

export default App;